<template>
  <div class="container">
    <div class="row">
      <div class="overviewAndNav mb-1">
        <h3 class="d-inline-block">Gedetailleerd overzicht van klant {{ selectedCustomerDetail.name }}</h3>
        <UpdateIcon v-if="!isUpdateMode" @clicked="toggleUpdateMode"/>
      </div>
    </div>
    <div class="row d-flex justify-content-center text-center my-3">
      <section>
        <button
            v-if="selectedCustomerDetail.active" class="btn-basic btn-fill-pulse-dark mr-2"
            style="width: 180px;"
            @click="toggleCustomerActiveState(false)" :disabled="isChangingActiveState">
          Klant inactief zetten
        </button>
        <button
            v-else class="btn-basic btn-fill-pulse mr-2"
            style="width: 180px;"
            @click="toggleCustomerActiveState(true)" :disabled="isChangingActiveState">
          Klant activeren
        </button>
      </section>
    </div>
    <div class="row">
      <div class="col-lg-6 text-right">
        <div class="text-left d-inline-block">
          <p class="py-2">Id</p>
          <p class="py-2">Naam</p>
          <p class="py-2">Afkorting</p>
          <p class="py-2">Naam supervisor</p>
          <p class="py-2">Email supervisor</p>
          <p class="py-2">Startuur dag</p>
          <p class="py-2">Startuur avond</p>
          <p class="py-2">Startuur nacht</p>
          <p class="py-2">Moederbedrijf</p>
          <p class="py-2">BTW-nummer</p>
          <p :class="{'py-4': isUpdateMode, 'py-2': !isUpdateMode}">Factuuradres</p>
          <p :class="{'py-4': isUpdateMode, 'py-2': !isUpdateMode}">Gemeente</p>
          <p class="py-2">Naam geadresseerde factuur</p>
          <p class="py-2">E-mail(s) geadresseerde factuur</p>
          <p class="py-2">Stuur factuur naar PEPPOL</p>
          <p class="py-2">Type Nummer PEPPOL</p>
          <p class="py-2">Nummer PEPPOL</p>
          <p class="py-2">Facturatienaam bedrijf</p>
          <p class="py-2">Betalingstermijn</p>
          <p class="py-2">Factuur en timesheet in één pdf</p>
        </div>
      </div>
      <div class="col-lg-6 text-left">
        <p class="py-2">{{ selectedCustomerDetail.id }}</p>
        <p class="py-2" v-if="!isUpdateMode">{{ selectedCustomerDetail.name }}</p>
        <p class="py-2" v-if="!isUpdateMode">{{ selectedCustomerDetail.abbreviation }}</p>
        <p class="py-2" v-if="!isUpdateMode && selectedCustomerDetail.supervisor">{{ selectedCustomerDetail.supervisor.name }}</p>
        <p class="py-2" v-if="!isUpdateMode && selectedCustomerDetail.supervisor">{{ selectedCustomerDetail.supervisor.email }}</p>
        <p class="py-2" v-if="!isUpdateMode">{{ selectedCustomerDetail.customerHours.morning }}</p>
        <p class="py-2" v-if="!isUpdateMode">{{ selectedCustomerDetail.customerHours.evening }}</p>
        <p class="py-2" v-if="!isUpdateMode">{{ selectedCustomerDetail.customerHours.night }}</p>
        <p class="py-2" v-if="!isUpdateMode && selectedParentCompany != null">{{ selectedParentCompany.abbreviation }}</p>
        <p class="py-2" v-if="!isUpdateMode && selectedParentCompany == null">/</p>
        <p class="py-2" v-if="!isUpdateMode">{{ selectedCustomerDetail.vat }}</p>
        <p class="py-2" v-if="!isUpdateMode && selectedCustomerDetail.customerInvoiceAddress">{{ selectedCustomerDetail.customerInvoiceAddress.street }},
          {{ selectedCustomerDetail.customerInvoiceAddress.houseNumber }}</p>
        <p class="py-2" v-if="!isUpdateMode && selectedCustomerDetail.customerInvoiceAddress">{{ selectedCustomerDetail.customerInvoiceAddress.postalCode }}
          {{ selectedCustomerDetail.customerInvoiceAddress.city }}</p>
        <p class="py-2" v-if="!isUpdateMode"> {{ selectedCustomerDetail.invoiceAddressingDto.financialSupervisorReference }}</p>
        <p class="py-2" v-if="!isUpdateMode"> <a v-for="confirmedEmailDto in selectedCustomerDetail.confirmedEmailDtos" :style="setColor(confirmedEmailDto.confirmed)" :key="confirmedEmailDto.emailAddress">{{confirmedEmailDto.emailAddress}}, </a></p>
        <p class="py-2" v-if="!isUpdateMode ">{{selectedCustomerDetail.peppolEndpointDto.active}} </p>
        <p class="py-2" v-if="!isUpdateMode ">{{selectedCustomerDetail.peppolEndpointDto.type}} </p>
        <p class="py-2" v-if="!isUpdateMode ">{{selectedCustomerDetail.peppolEndpointDto.number}} </p>
        <p class="py-2" v-if="!isUpdateMode"> {{ selectedCustomerDetail.invoiceAddressingDto.organisationName }}</p>
        <p class="py-2" v-if="!isUpdateMode && selectedCustomerDetail.paymentTerm">{{ selectedCustomerDetail.paymentTerm }} dagen</p>
        <p class="py-2" v-if="!isUpdateMode">{{ selectedCustomerDetail.wantsConcatenatedDocuments }} </p>

        <ValidationObserver
            v-if="isUpdateMode" v-slot="{ invalid, handleSubmit }"
            slim>
          <form @submit.prevent="handleSubmit(saveForm)">
            <TextInputField
                class="mt-3_2 negative-ml" v-model="updatedName"
                labelText="naam" required
                minLength="3" maxLength="40"
                inline/>
            <TextInputField
                class="mt-3_5 negative-ml" v-model="updatedAbbreviation"
                labelText="afkorting" required
                minLength="3" maxLength="10"
                inline/>
            <TextInputField
                class="mt-3_2 negative-ml" v-model="updatedSupervisorName"
                labelText="supervisor" required
                minLength="3" maxLength="40"
                inline/>
            <TextInputField
                class="mt-3_2 negative-ml" v-model="updatedSupervisorEmail"
                labelText="email" required
                minLength="3" maxLength="120"
                inline/>
            <TimeInputField
                class="mt-3_5 negative-ml" v-model="updatedMorning"
                labelText="ochtend" required
                inline/>
            <TimeInputField
                class="mt-3_5 negative-ml" v-model="updatedEvening"
                labelText="avond" required
                inline/>
            <TimeInputField
                class="mt-3_5 negative-ml" v-model="updatedNight"
                labelText="nacht" required
                inline/>
            <label class="mt-3_5 negative-ml">
              <select v-model="updatedParentCompany" @change="onParentSelection" class="form-control">
                <option
                    v-for="parentCompany in sortedCustomers"
                    :key="parentCompany.id"
                    :value="parentCompany.id">{{ parentCompany.name }}
                </option>
              </select>
            </label>
            <TextInputField
                class="mt-2 negative-ml" v-model="updatedVat"
                labelText="BTW-nummer" required
                minLength="3" maxLength="40"
                inline/>
            <div class="d-flex">
              <TextInputField
                  class="mt-3_5 negative-ml mr-1" v-model="updatedStreet"
                  labelText="straat" required
                  minLength="3" maxLength="40"/>
              <TextInputField
                  class="mt-3_5" v-model="updatedHouseNumber"
                  labelText="Huisnummer" required
                  minLength="1" maxLength="40"/>
            </div>
            <div class="d-flex">
              <TextInputField
                  class="mt-3_5 negative-ml mr-1" v-model="updatedPostalCode"
                  labelText="postcode" required
                  minLength="4" maxLength="4"/>
              <TextInputField
                  class="mt-3_5" v-model="updatedCity"
                  labelText="stad" required
                  minLength="3" maxLength="40"/>
            </div>
            <TextInputField
                class="mt-3_5 negative-ml" v-model="updatedFinancialSupervisorReference"
                labelText="aangeschrevene" required
                minLength="1" maxLength="40"
            inline/>
            <div class="d-flex">
              <multiselect
                  class="mt-3_5 negative-ml"
                  v-model="updatedFinancialSupervisorReferenceEmails"
                  :options="confirmedEmails"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Selecteer één of meerdere"
                  label="emailAddress"
                  track-by="emailAddress"
                  :preselect-first="true"
                  :taggable="true"
                  @tag="addTag">
              </multiselect>
            </div>

            <input type="checkbox" class="mt-3_5 negative-ml" v-model="updatedInvoiceToPeppol">
            <select v-model="updatedPeppolNumberType" class="form-control mt-3_5 negative-ml select">
              <option :value="null" disabled>Kies een nummerType</option>
              <option
                  v-for="dropdownElement in peppolNumberTypeOptions"
                  :key="dropdownElement.id"
                  :value="dropdownElement.value">{{ dropdownElement.value }}
              </option>
            </select>
            <TextInputField
                class="mt-3_5 negative-ml" v-model="updatedPeppolNumber"
                labelText="PeppolNummer" required
                minLength="1"
                inline/>
            <TextInputField
                class="mt-3_5 negative-ml" v-model="updatedOrganisationName"
                labelText="organisatienaam" required
                minLength="1" maxLength="40"
            inline/>
            <select v-model="updatedPaymentTerm" class="form-control mt-3_5 negative-ml select">
              <option :value="null" disabled>Kies een betalingstermijn</option>
              <option
                  v-for="dropdownElement in paymentTermOptions"
                  :key="dropdownElement.id"
                  :value="dropdownElement.value">{{ dropdownElement.value }} dagen
              </option>
            </select>
            <input type="checkbox" class="mt-3_5 negative-ml" v-model="updatedWantsConcatenatedDocuments">

            <div class="form-row align-items-center py-2">
              <div class="input-group col-lg-4 d-flex flex-row-reverse">
                <button
                    type="submit" :disabled="invalid"
                    class="remove-button-look">
                  <SaveIcon class="mr-3" />
                </button>
                <CancelIcon class="mr-3" @clicked="toggleUpdateMode"/>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <div class="row d-flex justify-content-between align-items-center mt-5">
      <button class="btn-basic invisible">Annuleren</button>
      <h5 class="display-4" style="font-size: 1.5em;">Shift types</h5>
      <button
          v-if="showCreateShiftType"
          class="btn-basic btn-fill-pulse-dark" @click="toggleCreateShiftType">Annuleren
      </button>
      <button
          v-else
          class="btn-basic btn-fill-pulse" @click="toggleCreateShiftType">Toevoegen
      </button>
    </div>
    <div class="row" v-if="showCreateShiftType">
      <CreateShiftTypeComponent
          :customerId="selectedCustomerDetail.id" @shiftTypeAdded="toggleCreateShiftType"/>
    </div>

    <div class="row mt-4">
      <table class="table">
        <thead class="thead-dark">
        <tr>
          <SortableTableHeaderComponent
              columnName="name" :sortColumn="currentShiftTypesSortColumn"
              :sortDirectionAscending="currentShiftTypesSortDirectionAscending" :sortFunction="sortShiftTypes"
              text="Naam shift"/>
          <SortableTableHeaderComponent
              columnName="labourTime" :sortColumn="currentShiftTypesSortColumn"
              :sortDirectionAscending="currentShiftTypesSortDirectionAscending" :sortFunction="sortShiftTypes"
              text="Werkuren"/>
          <SortableTableHeaderComponent
              columnName="break" :sortColumn="currentShiftTypesSortColumn"
              :sortDirectionAscending="currentShiftTypesSortDirectionAscending" :sortFunction="sortShiftTypes"
              text="Pauze-uren"/>
          <SortableTableHeaderComponent
              columnName="active" :sortColumn="currentShiftTypesSortColumn"
              :sortDirectionAscending="currentShiftTypesSortDirectionAscending" :sortFunction="sortShiftTypes"
              text="Status"/>
          <th scope="col">Actie</th>
        </tr>
        </thead>
        <tbody>
        <tr :key="shiftTypeDto.id" v-for="shiftTypeDto in sortedShiftTypes" v-show="!shiftTypeDto.archived" >
          <td :bgcolor="shiftTypeDto.color" :style="{color: giveTextColorForBackGroundColor(shiftTypeDto.color)}" >
            {{ shiftTypeDto.name }}
          </td>
          <td>{{ timeIntervalToReadableFormat(shiftTypeDto.labourTime) }}</td>
          <td>{{ timeIntervalToReadableFormat(shiftTypeDto.breakTime) }}</td>
          <td>{{ getActiveText(shiftTypeDto.active) }}</td>
          <td>
            <button
                class="btn-basic btn-outline-pulse w-auto mr-2" @click="openEditShiftType(shiftTypeDto)">
              Shift type aanpassen
            </button>
            <button
                class="btn-basic btn-outline-pulse-dark mr-2" @click="flipShiftActivity(shiftTypeDto)"
                :disabled="checkShiftTypeUpdating(shiftTypeDto.id)">
              <Spinner v-show="checkShiftTypeUpdating(shiftTypeDto.id)"/>
              {{ checkShiftTypeUpdating(shiftTypeDto.id) || getActivateText(shiftTypeDto.active) }}
            </button>
            <button
              class="btn-basic btn-outline-pulse-dark" @click="flipShiftArchived(shiftTypeDto.id)"
              :disabled="checkShiftTypeUpdating(shiftTypeDto.id)">
              <Spinner v-show="checkShiftTypeUpdating(shiftTypeDto.id)"/>
              Archiveer
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="row" v-if="showEditShiftType">
      <EditShiftTypeComponent
          :shiftTypeDtoToEdit="selectedShiftTypeDto"
          :customerId="selectedCustomerDetail.id" @shiftTypeEdited="closeEditShiftType"/>
    </div>


    <div class="row d-flex justify-content-between align-items-center mt-5">
      <button class="btn-basic invisible">Annuleren</button>
      <h5 class="display-4" style="font-size: 1.5em;">Bonus tarieven</h5>
      <button
          v-if="showCreateBonusRate"
          class="btn-basic btn-fill-pulse-dark" @click="toggleCreateBonusRate">Annuleren
      </button>
      <button
          v-else
          class="btn-basic btn-fill-pulse" @click="toggleCreateBonusRate">Toevoegen
      </button>
    </div>
    <div class="form-row align-items-center py-1" v-if="showCreateBonusRate">
      <CreateBonusRateComponent
          :customerId="selectedCustomerDetail.id" @BonusRateAdded="toggleCreateBonusRate"/>
    </div>
    <div class="row mt-4">
      <table class="table">
        <thead class="thead-dark">
        <tr>
          <SortableTableHeaderComponent
              columnName="bonusType" :sortColumn="currentBonusRateSortColumn"
              :sortDirectionAscending="currentBonusRatesSortDirectionAscending" :sortFunction="sortBonusRates"
              text="BonusType"/>
          <SortableTableHeaderComponent
              columnName="percentage" :sortColumn="currentBonusRateSortColumn"
              :sortDirectionAscending="currentBonusRatesSortDirectionAscending" :sortFunction="sortBonusRates"
              text="Percentages"/>
          <th scope="col">Actie</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="bonusRateDto in sortedBonusRates">
          <EditBonusRateComponent
              :key="bonusRateDto.bonusType" :bonusRateDto="bonusRateDto"
              from="customerDetail"/>
        </template>
        </tbody>
      </table>
    </div>


    <div class="row d-flex justify-content-between align-items-center mt-5">
      <button class="btn-basic invisible">Annuleren</button>
      <h5 class="display-4" style="font-size: 1.5em;">Contracten</h5>
      <button
          v-if="showCreateContract"
          class="btn-basic btn-fill-pulse-dark" @click="toggleCreateContract">Annuleren
      </button>
      <button
          v-else
          class="btn-basic btn-fill-pulse" @click="toggleCreateContract">Toevoegen
      </button>
    </div>
    <div class="row" v-show="showCreateContract">
      <CreateContractFromCustomerComponent
          :customerId="selectedCustomerDetail.id" @contractAdded="toggleCreateContract"/>
    </div>
    <div class="row mt-4">
      <table class="table">
        <thead class="thead-dark">
        <tr>
          <SortableTableHeaderComponent
              columnName="id" :sortColumn="currentContractsSortColumn"
              :sortDirectionAscending="currentContractsSortDirectionAscending" :sortFunction="sortContracts"
              text="Contract id"/>
          <SortableTableHeaderComponent
              columnName="userId" :sortColumn="currentContractsSortColumn"
              :sortDirectionAscending="currentContractsSortDirectionAscending" :sortFunction="sortContracts"
              text="Gebruiker id"/>
          <SortableTableHeaderComponent
              columnName="username" :sortColumn="currentContractsSortColumn"
              :sortDirectionAscending="currentContractsSortDirectionAscending" :sortFunction="sortContracts"
              text="Gebruikersnaam"/>
          <SortableTableHeaderComponent
              columnName="contractPeriod" :sortColumn="currentContractsSortColumn"
              :sortDirectionAscending="currentContractsSortDirectionAscending" :sortFunction="sortContracts"
              text="Contract periode"/>
          <th scope="col">Acties</th>
        </tr>
        </thead>
        <template v-for="contractSummaryDto in sortedContracts">
          <ContractTableRowComponent
              :key="contractSummaryDto.id" :contractSummaryDto="contractSummaryDto"
              from="customerDetail"/>
        </template>
      </table>
    </div>


    <div class="row d-flex justify-content-between align-items-center mt-5">
      <button class="btn-basic invisible">Annuleren</button>
      <h5 class="display-4" style="font-size: 1.5em;">Subdivisies</h5>
      <button
          v-if="showAddSubdivision"
          class="btn-basic btn-fill-pulse-dark" @click="toggleAddSubdivision">Annuleren
      </button>
      <button
          v-else :disabled="availableSubdivisions.length === 0"
          class="btn-basic btn-fill-pulse" @click="toggleAddSubdivision">Toevoegen
      </button>
    </div>
    <div class="row" v-show="showAddSubdivision">
      <addSubdivisionComponent :availableSubdivisions="availableSubdivisions"></addSubdivisionComponent>
    </div>
    <div v-if="this.selectedSubdivisions == null" class="row d-flex justify-content-center mt-4">
      <p><b>{{ this.selectedCustomerDetail.name }}</b> heeft geen subdivisies.</p>
    </div>
    <div v-if="this.selectedSubdivisions !== null" class="row mt-4">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
          <tr>
            <SortableTableHeaderComponent
                columnName="id" :sortColumn="currentSubdivisionSortColumn"
                :sortDirectionAscending="currentSubdivisionSortDirectionAscending" :sortFunction="sortedSubdivisions"
                text="Klant id"/>
            <SortableTableHeaderComponent
                columnName="name" :sortColumn="currentSubdivisionSortColumn"
                :sortDirectionAscending="currentSubdivisionSortDirectionAscending" :sortFunction="sortedSubdivisions"
                text="Naam klant"/>
            <SortableTableHeaderComponent
                columnName="abbreviation" :sortColumn="currentSubdivisionSortColumn"
                :sortDirectionAscending="currentSubdivisionSortDirectionAscending" :sortFunction="sortedSubdivisions"
                text="Afkorting"/>
          </tr>
          </thead>
          <template v-for="subdivision in selectedSubdivisions">
            <tr :key="subdivision.id">
              <td>{{ subdivision.id }}</td>
              <td>{{ subdivision.name }}</td>
              <td>{{ subdivision.abbreviation }}</td>
            </tr>
          </template>
        </table>
      </div>
    </div>
    <ImportParentCompanyModal
      :parentCompany="this.selectedParentCompanyDetail"
      @update-chosen-fields="updateChosenFieldsFromParent"
      @close="closeModalImportParentCompanyValues"/>
    <importDataToSubdivisionsModal
        :subdivisions="this.selectedSubdivisions"
        @subdivisions-to-update="updateSelectedSubdivisions"
        @close="closeModalimportDataToSubdivisionsModal"/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {giveTextColorForBackGroundColor} from "@/util/ColorUtil";
import CreateContractFromCustomerComponent from "@/Admin/CreateContractComponent/CreateContractFromCustomerComponent";
import FilterModes from "../constants/FilterConstants";
import CreateShiftTypeComponent from "@/Admin/ShiftTypeComponent/CreateShiftTypeComponent";
import EditShiftTypeComponent from "@/Admin/ShiftTypeComponent/EditShiftTypeComponent";
import {ValidationObserver} from "vee-validate";
import UpdateIcon from "@/components/icons/Pencil";
import CancelIcon from "@/components/icons/Ban";
import SaveIcon from "@/components/icons/Save";
import Spinner from "@/components/loader/Spinner";
import ContractTableRowComponent from "@/Admin/ContractTableRowComponent/ContractTableRowComponent";
import {sortListByColumnAndDirection} from "@/util/SortingUtil";
import SortableTableHeaderComponent from "@/components/tables/SortableTableHeader";
import TextInputField from "@/components/inputFields/TextInputField";
import AddSubdivisionComponent from "@/Admin/SubdivisionComponent/addSubdivisionComponent";
import TimeInputField from "@/components/inputFields/TimeInputField";
import CreateBonusRateComponent from "@/Admin/BonusRateComponent/CreateBonusRateComponent";
import EditBonusRateComponent from "@/Admin/BonusRateComponent/EditBonusRateComponent";
import Multiselect from "vue-multiselect";
import {VoerroModal} from "@voerro/vue-modal";
import ImportParentCompanyModal from "@/components/modals/ImportParentCompanyModal.vue";
import importDataToSubdivisionsModal from "@/components/modals/ImportDataToSubdivisionsModal.vue";

export default {
  name: "AdminCustomerDetail",
  components: {
    importDataToSubdivisionsModal,
    Multiselect,
    TimeInputField,
    AddSubdivisionComponent,
    TextInputField,
    SortableTableHeaderComponent,
    ContractTableRowComponent,
    Spinner,
    CreateContractFromCustomerComponent,
    SaveIcon,
    CancelIcon,
    UpdateIcon,
    CreateShiftTypeComponent,
    CreateBonusRateComponent,
    EditShiftTypeComponent,
    EditBonusRateComponent,
    ValidationObserver,
    ImportParentCompanyModal
  },
  data() {
    return {
      isUpdateMode: false,
      showCreateContract: false,
      showCreateShiftType: false,
      showCreateBonusRate: false,
      showEditShiftType: false,
      showAddSubdivision: false,
      showEditBonusRate: false,
      updatedName: "",
      updatedAbbreviation: "",
      updatedSupervisor: "",
      updatedSupervisorEmail: "",
      updatedSupervisorName: "",
      updatedMorning: "",
      updatedEvening: "",
      updatedNight: "",
      updatedParentCompany: null,
      updatedVat: "",
      updatedStreet: "",
      updatedHouseNumber: "",
      updatedPostalCode: "",
      updatedCity: "",
      updatedOrganisationName: "",
      updatedFinancialSupervisorReferenceEmails: [],
      updatedFinancialSupervisorReference: "",
      updatedWantsConcatenatedDocuments: false,
      updatedInvoiceToPeppol: false,
      updatedPeppolNumber: "",
      updatingShiftTypeIds: [],
      currentShiftTypesSortColumn: "labourTime",
      currentBonusRateSortColumn: "bonusType",
      currentShiftTypesSortDirectionAscending: true,
      currentBonusRatesSortDirectionAscending: true,
      currentContractsSortColumn: "contractPeriod",
      currentContractsSortDirectionAscending: true,
      selectedShiftTypeDto: {},
      selectedBonusRateDto: {},
      hourlyRate: {
        startDate: "",
        endDate: "",
        baseHourlyRate: undefined,
      },
      addHourlyRateMode: true,
      currentSubdivisionSortColumn: "name",
      currentSubdivisionSortDirectionAscending: true,
      search: '',
      isChangingActiveState: false,
      updatedPaymentTerm: 0,
      updatedPeppolNumberType: 0,
      paymentTermOptions: [{"id": 1, "value": 30}, {"id": 2, "value": 60}, {"id": 3, "value": 90}],
      peppolNumberTypeOptions: [{"id":1,"value":"VAT"}, {"id":2,"value":"GNL"}],
      updatedConfirmedEmail: "",
      selectConfirmedEmail: false,
    };
  },
  computed: {
    ...mapGetters({
      selectedCustomerDetail: "administrationCustomer/selectedCustomerDetail",
      selectedParentCompany: "administrationCustomer/selectedParentCompany",
      selectedParentCompanyDetail: "administrationCustomer/selectedParentCompanyDetail",
      selectedSubdivisions: "administrationCustomer/selectedSubdivisions",
      availableSubdivisions: "administrationCustomer/availableSubdivisions",
      customers: "administrationCustomer/customers",
      confirmedEmails: "administrationCustomer/confirmedEmails"
    }),
    setColor() {
      return confirmed => {
        if(confirmed === true) {
          this.isColor = 'green';
        } else {
          this.isColor = 'red';
        }
        return { color: this.isColor };
      };
    },
    sortedCustomers: function () {
      let sortedList = sortListByColumnAndDirection(this.customers, "id", true);
      return sortedList.filter(customer => {
        return (customer.id !== this.selectedCustomerDetail.id)&&(customer.parentCompanyId === 0);
      }).filter(customer => {
        return customer.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    sortedShiftTypes: function () {
      const shiftTypes = [...this.selectedCustomerDetail.shiftTypeDtos || []];

      if (this.currentShiftTypesSortColumn === "labourTime" || this.currentShiftTypesSortColumn === "break") {
        return sortListByColumnAndDirection(shiftTypes, this.currentShiftTypesSortColumn, this.currentShiftTypesSortDirectionAscending, this.timeIntervalToReadableFormat);
      }
      if (this.currentShiftTypesSortColumn === "active") {
        return sortListByColumnAndDirection(shiftTypes, this.currentShiftTypesSortColumn, this.currentShiftTypesSortDirectionAscending, this.getActiveText);
      }
      return sortListByColumnAndDirection(shiftTypes, this.currentShiftTypesSortColumn, this.currentShiftTypesSortDirectionAscending);
    },
    sortedBonusRates: function () {
      const bonusRates = [...this.selectedCustomerDetail.bonusRateDtos || []];
      return sortListByColumnAndDirection(bonusRates, this.currentBonusRateSortColumn, this.currentBonusRatesSortDirectionAscending);
    },
    sortedContracts() {
      const contracts = [...this.selectedCustomerDetail.contractSummaryDtos || []];

      if (this.currentContractsSortColumn === "contractPeriod") {
        if (this.currentContractsSortDirectionAscending) {
          return contracts;
        }
        return contracts.reverse();
      }
      return sortListByColumnAndDirection(contracts, this.currentContractsSortColumn, this.currentContractsSortDirectionAscending);
    },
    sortedSubdivisions() {
      return sortListByColumnAndDirection(this.selectedSubdivisions, this.currentSubdivisionSortColumn, this.currentSubdivisionSortColumn);
    }
  },
  async created() {
    await this.fetchDetailsForSelectedCustomer();
    await this.fetchBonusTypes();
    await this.fetchConfirmedEmailsList();
    this.updatedPaymentTerm = this.selectedCustomerDetail.paymentTerm;
    this.updatedPeppolNumberType = this.selectedCustomerDetail.peppolEndpointDto.type;
  },
  methods: {
    ...mapActions("administrationUser", ["fetchUsers"]),
    ...mapActions("administrationTimeSheet", ["createContract"]),
    ...mapActions("administrationCustomer",
        ["fetchDetailsForSelectedCustomer", "fetchDetailsForParentCustomer", "updateShiftTypeFromCustomer", "fetchConfirmedEmailsList", "updateShiftTypeActivityFromCustomer", "updateCustomer", "updateBonusRateFromCustomer", "updateSubdivisionsFromCustomer", "replaceBonusRatesFromCustomer", "fetchBonusTypes", "toggleCustomerActive", "archiveShiftTypeFromCustomer"]),
    giveTextColorForBackGroundColor(color) {
      return giveTextColorForBackGroundColor(color);
    },
    addTag (newTag) {
      const tag = {
        confirmationDateTime: null,
        confirmed: false,
        confirmer: null,
        emailAddress: newTag,
        token: null,
      };
      this.updatedFinancialSupervisorReferenceEmails.push(tag);
      this.confirmedEmails.push(tag);
    },
    toggleCreateShiftType() {
      this.showCreateShiftType = !this.showCreateShiftType;
    }, toggleCreateBonusRate() {
      this.showCreateBonusRate = !this.showCreateBonusRate;
    },
    openEditShiftType(shiftTypeDto) {
      this.selectedShiftTypeDto = shiftTypeDto;
      this.showEditShiftType = true;
    },
    openEditBonusRate(bonusRateDto) {
      this.selectedBonusRateDto = bonusRateDto;
      this.showEditBonusRate = true;
    },
    closeEditShiftType() {
      this.showEditShiftType = false;
    }
    , closeEditBonusRate() {
      this.showEditBonusRate = false;
    },
    toggleCreateContract() {
      this.showCreateContract = !this.showCreateContract;
    },
    toggleHourlyRateAddition() {
      this.addHourlyRateMode = !this.addHourlyRateMode;
    },
    toggleAddSubdivision() {
      this.showAddSubdivision = !this.showAddSubdivision;
    },
    async flipShiftActivity(shiftTypeDto) {
      const updateShiftTypeDto = {
        id: shiftTypeDto.id,
        active: !shiftTypeDto.active
      };
      this.updatingShiftTypeIds.push(shiftTypeDto.id);
      await this.updateShiftTypeActivityFromCustomer(updateShiftTypeDto).then(() => {
        this.removeIdFromUpdatingShiftTypeIds(shiftTypeDto.id);
      }).catch(() => {
        this.removeIdFromUpdatingShiftTypeIds(shiftTypeDto.id);
      });
    },
    async flipShiftArchived(shiftTypeId) {
      this.updatingShiftTypeIds.push(shiftTypeId);
      await this.archiveShiftTypeFromCustomer(shiftTypeId).then(() => {
        this.removeIdFromUpdatingShiftTypeIds(shiftTypeId);
      }).catch(() => {
        this.removeIdFromUpdatingShiftTypeIds(shiftTypeId);
      });
    },
    removeIdFromUpdatingShiftTypeIds(shiftTypeId) {
      const indexOfId = this.updatingShiftTypeIds.indexOf(shiftTypeId);
      if (indexOfId !== -1) {
        this.updatingShiftTypeIds.splice(indexOfId, 1);
      }
    },
    toggleUpdateMode() {
      this.updatedName = this.selectedCustomerDetail.name;
      this.updatedAbbreviation = this.selectedCustomerDetail.abbreviation;
      this.updatedSupervisorName = this.selectedCustomerDetail.supervisor.name;
      this.updatedSupervisorEmail = this.selectedCustomerDetail.supervisor.email;
      this.updatedMorning = this.selectedCustomerDetail.customerHours.morning;
      this.updatedEvening = this.selectedCustomerDetail.customerHours.evening;
      this.updatedNight = this.selectedCustomerDetail.customerHours.night;
      this.updatedParentCompany = this.selectedCustomerDetail.parentCompanyId;
      this.updatedVat = this.selectedCustomerDetail.vat;
      this.updatedStreet = this.selectedCustomerDetail.customerInvoiceAddress.street;
      this.updatedHouseNumber = this.selectedCustomerDetail.customerInvoiceAddress.houseNumber;
      this.updatedPostalCode = this.selectedCustomerDetail.customerInvoiceAddress.postalCode;
      this.updatedCity = this.selectedCustomerDetail.customerInvoiceAddress.city;
      this.updatedOrganisationName = this.selectedCustomerDetail.invoiceAddressingDto.organisationName;
      this.updatedFinancialSupervisorReferenceEmails = this.selectedCustomerDetail.confirmedEmailDtos;
      this.updatedFinancialSupervisorReference = this.selectedCustomerDetail.invoiceAddressingDto.financialSupervisorReference;
      this.updatedWantsConcatenatedDocuments = this.selectedCustomerDetail.wantsConcatenatedDocuments;
      this.updatedInvoiceToPeppol = this.selectedCustomerDetail.peppolEndpointDto.active;
      this.updatedPeppolNumber = this.selectedCustomerDetail.peppolEndpointDto.number;
      this.fetchDetailsForSelectedCustomer();
      this.isUpdateMode = !this.isUpdateMode;
    },
    async onParentSelection() {
      if (this.updatedParentCompany !== this.selectedCustomerDetail.parentCompanyId) {
        await this.fetchDetailsForParentCustomer(this.updatedParentCompany);
        await this.toggleModalImportParentCompanyValues();
      }
    },
    toggleModalImportParentCompanyValues() {
      VoerroModal.show('importParentCompanyValues');
    },
    closeModalImportParentCompanyValues() {
      VoerroModal.hide('importParentCompanyValues');
    },
    toggleModalimportDataToSubdivisionsModal() {
      VoerroModal.show('importDataToSubdivisions');
    },
    closeModalimportDataToSubdivisionsModal() {
      VoerroModal.hide('importDataToSubdivisions');
    },
    resetFields() {
      this.hourlyRate.startDate = "";
      this.hourlyRate.endDate = "";
      this.hourlyRate.baseHourlyRate = undefined;
    },
    async saveForm() {
      const updateCustomerDto = {
        name: this.updatedName,
        abbreviation: this.updatedAbbreviation,
        supervisor: {
          name: this.updatedSupervisorName,
          email: this.updatedSupervisorEmail,
        },
        customerHours: {
          morning: this.updatedMorning,
          evening: this.updatedEvening,
          night: this.updatedNight,
        },
        parentCompanyId: this.updatedParentCompany,
        vat: this.updatedVat,
        customerInvoiceAddress: {
          street: this.updatedStreet,
          houseNumber: this.updatedHouseNumber,
          postalCode: this.updatedPostalCode,
          city: this.updatedCity,
        },
        invoiceAddressingDto: {
          financialSupervisorReference: this.updatedFinancialSupervisorReference,
          organisationName: this.updatedOrganisationName,
        },
        paymentTerm: this.updatedPaymentTerm,
        confirmedEmailDtos: this.updatedFinancialSupervisorReferenceEmails,
        wantsConcatenatedDocuments: this.updatedWantsConcatenatedDocuments,

        peppolEndpointDto: {
          active: this.updatedInvoiceToPeppol,
          number: this.updatedPeppolNumber,
          type: this.updatedPeppolNumberType,
        }
      };
      await this.updateCustomer(updateCustomerDto);
      this.toggleUpdateMode();
      if (this.selectedSubdivisions.length > 0) {
        this.toggleModalimportDataToSubdivisionsModal();
      }
    },
    updateChosenFieldsFromParent(checkboxValues, parentCompany) {
      if (checkboxValues.vat) {
        this.updatedVat = parentCompany.vat;
      }
      if (checkboxValues.invoiceAddress) {
        this.updatedStreet = parentCompany.customerInvoiceAddress.street;
        this.updatedHouseNumber = parentCompany.customerInvoiceAddress.houseNumber;
        this.updatedPostalCode = parentCompany.customerInvoiceAddress.postalCode;
        this.updatedCity = parentCompany.customerInvoiceAddress.city;
      }
      if (checkboxValues.organisation) {
        this.updatedOrganisationName = parentCompany.invoiceAddressingDto.organisationName;
        this.updatedFinancialSupervisorReference = parentCompany.invoiceAddressingDto.financialSupervisorReference;
        this.updatedFinancialSupervisorReferenceEmails = parentCompany.confirmedEmailDtos;
      }
      if (checkboxValues.bonusRate) {
        const parentBonusRateList = [];
        for (const bonusRateDto of parentCompany.bonusRateDtos) {
          parentBonusRateList.push(bonusRateDto);
        }
        this.replaceBonusRatesFromCustomer(parentBonusRateList);
      }
      if (checkboxValues.standardHours) {
        this.updatedMorning = parentCompany.customerHours.morning;
        this.updatedEvening = parentCompany.customerHours.evening;
        this.updatedNight = parentCompany.customerHours.night;
      }
      if (checkboxValues.paymentTerm) {
        this.updatedPaymentTerm = parentCompany.paymentTerm;
      }
      if (checkboxValues.supervisor) {
        this.updatedSupervisorName = parentCompany.supervisor.name;
        this.updatedSupervisorEmail = parentCompany.supervisor.email;
      }
    },
    updateSelectedSubdivisions(subdivisionsToUpdateIds) {
      this.updateSubdivisionsFromCustomer(subdivisionsToUpdateIds);
    },
    checkShiftTypeUpdating(shiftTypeId) {
      return this.updatingShiftTypeIds.indexOf(shiftTypeId) !== -1;
    },
    getActivateText(active) {
      return active ? "Deactiveren" : "Activeren";
    },
    timeIntervalToReadableFormat(interval) {
      if (interval) {
        return interval.startTime + " - " + interval.endTime;
      }
      return "/";
    },
    getActiveText(active) {
      return active ? FilterModes.ACTIVE : FilterModes.NOT_ACTIVE;
    },
    sortShiftTypes: function (newSortColumn) {
      if (newSortColumn === this.currentShiftTypesSortColumn) {
        this.currentShiftTypesSortDirectionAscending = !this.currentShiftTypesSortDirectionAscending;
      } else {
        this.currentShiftTypesSortDirectionAscending = true;
      }
      this.currentShiftTypesSortColumn = newSortColumn;
    },
    sortBonusRates: function (newSortColumn) {
      if (newSortColumn === this.currentBonusRateSortColumn) {
        this.currentBonusRatesSortDirectionAscending = !this.currentBonusRatesSortDirectionAscending;
      } else {
        this.currentBonusRatesSortDirectionAscending = true;
      }
      this.currentBonusRateSortColumn = newSortColumn;
    },
    sortContracts: function (newSortColumn) {
      if (newSortColumn === this.currentContractsSortColumn) {
        this.currentContractsSortDirectionAscending = !this.currentContractsSortDirectionAscending;
      } else {
        this.currentContractsSortDirectionAscending = true;
      }
      this.currentContractsSortColumn = newSortColumn;
    },
    toggleCustomerActiveState(activationStatus) {
      if ((!this.selectedCustomerDetail.active) || (confirm('Als deze klant subdivisies heeft worden deze ook gedeactiveerd. ' +
          'Ben je zeker dat je wenst verder te gaan?'))) {
        this.isChangingActiveState = true;
        const updateActivationStatusDto = {
          newActivationStatus: activationStatus
        };
        const promise = this.toggleCustomerActive(updateActivationStatusDto);
        promise.then(() => this.isChangingActiveState = false)
            .catch(() => this.isChangingActiveState = false);
      }
    },
  }
};
</script>

<style scoped>

.negative-ml {
  margin-left: -0.761rem;
}

.overviewAndNav {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.remove-button-look {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
}

.remove-button-look:disabled {
  cursor: default;
  opacity: 0.65;
}

.mt-3_2 {
  margin-top: 1.05rem !important;
}

.mt-3_5 {
  margin-top: 1.15rem !important;
}

.select {
  max-width: 180px;
}

</style>